// extracted by mini-css-extract-plugin
export var copyableField = "_rk-4";
export var customerBadge = "_rk-0";
export var customerInfoTitle = "_rk-2";
export var details = "_rk-1";
export var dropdownContainer = "_rk-5";
export var dropdownImage = "_rk-6";
export var editAssigneeForm = "_rk-a";
export var editButton = "_rk-3";
export var email = "_rk-7";
export var hidden = "_rk-d";
export var input = "_rk-8";
export var saveButton = "_rk-b";
export var shopifyIcon = "_rk-c";
export var suggestionBadge = "_rk-e";
export var suggestionText = "_rk-f";
export var username = "_rk-9";